import { useEffect } from 'react';
import useApplyAppUpdateOnNavigate from '../../hooks/useApplyAppUpdateOnNavigate';

/**
 * Owner of the PWA lifecycle hooks that need the router. Nothing is rendered:
 * the install-to-home-screen card is disabled (PWA install is an internal-only
 * affordance) and updates are applied silently by `src/pwa/appUpdate.ts`
 * rather than prompted for. `beforeinstallprompt`'s default is still
 * suppressed so Chromium's native install mini-infobar does not pop up.
 */
const PwaPrompts = () => {
  useApplyAppUpdateOnNavigate();

  useEffect(() => {
    const suppressNativeInstallPrompt = (event: Event) => {
      event.preventDefault();
    };

    window.addEventListener('beforeinstallprompt', suppressNativeInstallPrompt);
    return () =>
      window.removeEventListener(
        'beforeinstallprompt',
        suppressNativeInstallPrompt
      );
  }, []);

  return null;
};

export default PwaPrompts;
